import { Form, FormProps } from 'antd'
import { cleanObject } from 'shared/libs/obj/cleanObjFromNull'

import { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import AddUserInfo from 'modules/AccessManage/components/AddUserInfo'
import UserKeyAccess from 'modules/AccessManage/components/UserKeyAccess'
import { useUser } from 'modules/AccessManage/hooks/useUser'
import { EditUserInfoFormState } from 'modules/AccessManage/types'

import { Button } from 'shared/ui/Button'
import PrimaryButton from 'shared/ui/PrimaryButton'
import SkeletonNode from 'shared/ui/SkeletonNode'
import Title from 'shared/ui/Title'

const EditUser = () => {
  const { userId } = useParams()
  const navigate = useNavigate()
  const { user, handleUpdateUser, isGetUserFetching, isUpdateUserLoading } =
    useUser({
      userId,
    })

  const [form] = Form.useForm<EditUserInfoFormState>()

  const onFinish: FormProps<EditUserInfoFormState>['onFinish'] = (data) => {
    handleUpdateUser(data)
  }

  useEffect(() => {
    if (user) {
      form.setFieldsValue(
        cleanObject({
          ...user,
          role: user.role?.id ? `${user.role?.id}` : null,
          company: user?.company?.slug ?? null,
          branch: user?.branch?.slug ?? null,
        }),
      )
    }
  }, [user])

  return (
    <Form
      form={form}
      onFinish={onFinish}
      className="flex-1 flex flex-col"
    >
      <div className="flex-1 flex flex-col justify-between">
        <div className="p-[24px]">
          <div className="py-[12px]">
            <SkeletonNode
              loading={isGetUserFetching}
              className="!h-8 !w-full !max-w-96"
            >
              <Title
                className="!mb-0 !font-bold !leading-[32px] !text-dark_2"
                level={3}
              >
                {user?.full_name}
              </Title>
            </SkeletonNode>
          </div>
          <div className="mt-[28px] flex gap-[20px]">
            <AddUserInfo form={form} />
            <UserKeyAccess
              isFetching={isGetUserFetching}
              mode="edit"
              userInfo={user ?? null}
            />
          </div>
        </div>
        <div className="p-[24px] pt-[12px] flex justify-end gap-[8px] bg-light_gray_2">
          <Button
            onClick={() => navigate(-1)}
            disabled={isUpdateUserLoading}
            className="h-auto text-light_gray_17 text-[16px] leading-[24px] font-semibold border-none bg-white rounded-[16px]"
          >
            Отменить изменения
          </Button>
          <PrimaryButton
            className="rounded-[16px]"
            htmlType="submit"
            text="Сохранить"
            disabled={isGetUserFetching || isUpdateUserLoading}
          />
        </div>
      </div>
    </Form>
  )
}

export default EditUser
